module.exports = __webpack_public_path__ + "static/flags/BE-72d41da93b7543f82d91065e8e3cc988.gif";